import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us.webp");
;
import(/* webpackMode: "eager" */ "/app/public/images/about-us2.webp");
